













































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class FooterToolbar extends Vue {
  @Prop({ type: Object, default() {
    return {};
  }})
  private toolbarStyle!: any;
}
